import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {ToasterPosition} from '../_services/interceptor.service';

import moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {FileNameData} from '../_model/FileNameData';
import {PortalDocumentResponse} from '../_model/response/PortalDocumentResponse';
import {AbstractControl} from '@angular/forms';
import {AppConstants} from '../_utils/constants';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {


    constructor(private toastr: ToastrService) {
    }

    showSuccess(title: string, message: string, positionClass: ToasterPosition) {
        this.toastr.success(message, title, {positionClass});
    }

    showWarning(title: string, message: string, positionClass: ToasterPosition) {
        this.toastr.warning(message, title, {positionClass});
    }

    showAlert(title: string, message: string, positionClass: ToasterPosition) {
        this.toastr.error(message, title, {positionClass});
    }

    longToDay(longParam) {
        return Math.round(longParam / (1000 * 3600 * 24));
    }

    longToHour(longParam) {
        return Math.round(longParam / (1000 * 3600));
    }

    longToHourWithDecimalFix(longParam: number) {
        return Number((longParam / (1000 * 3600)).toFixed(1));
    }

  public formatDateForSorting(date: string){
    let result = "";
    result = date.substr(6,4)+'-'+date.substr(3,2) +'-'+date.substr(0,2) + 'T'  + date.substr(11,2) +':'+ date.substr(14,2);
    return new Date(result);
  }

    public toTurkishLowerCase(word: string) {
        let result = word;
        const letters = {İ: 'i', I: 'ı', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç'};
        result = result.replace(/(([İIŞĞÜÇÖ]))/g, letter => letters[letter]);
        return result.toLowerCase();
    }

    public toTurkishUpperCase(word: string) {
        let result = word;
        const letters = {i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I'};
        result = result.replace(/(([iışğüçö]))/g, letter => letters[letter]);
        return result.toUpperCase();
    }


    /**
     * elde bulunan saat miktarini izin suresine donusturen fonksiyon
     * ornek: 50 saat ise
     * 50/24 ten 2 gun elde var
     * 50%24 e gore de 2 kaliyor ve 4 saate kadar yarim gun sayildigi icin elimizde 0.5 gun oluyor
     * toplamda 2.5 gun izin oluyor
     *
     * @param timeType ile de iznin zaman turu belirtiliyor
     * bu gunluk yani 1, 1.5, 2 gun seklinde de olabilir
     * saatlik yani 0.1, 0.2, 0.3 gun seklinde de olabilir. Yani yuvarlanmayacak
     */
    convertHourToAbsenceTime(hourAmount, timeType, absenceTypeId) {
        console.log('hour amount = ' + hourAmount + ' timetype=' + timeType + ' ' + absenceTypeId);
        if (timeType === 'DAILY') {
            let dayResult = Math.floor(hourAmount / 24);
            if (hourAmount % 24 !== 0) {
                if (hourAmount % 24 > 0 && hourAmount % 24 <= 4) {
                    dayResult += 0.5;
                } else {
                    dayResult++;
                }
            }
            return dayResult;
        } else if (timeType === 'HOURLY') {
            /**TODO saatlik izinlerde ne kadar giriliyorsa o kadar kabul edilecek
             * let hourResult = Math.floor(hourAmount / 24) * 8;
            if (hourAmount % 24 !== 0) {
                if (hourAmount % 24 > 0 && hourAmount % 24 <= 8) {
                    hourResult += hourAmount % 24;
                } else {
                    hourResult += 8;
                }
            }
            if (absenceTypeId === 22) {
                return Math.floor((hourResult) * 100) / 100;
            } else {
                return Number(hourResult.toFixed(1));
            }*/
            return hourAmount;
        }
    }

    convertHourToOvertimeTime(hourAmount, timeType, absenceTypeId) {
        console.log('hour amount = ' + hourAmount + ' timetype=' + timeType + ' ' + absenceTypeId);
        if (timeType === 'DAILY') {
            let dayResult = Math.floor(hourAmount / 24);
            if (hourAmount % 24 !== 0) {
                if (hourAmount % 24 > 0 && hourAmount % 24 <= 4) {
                    dayResult += 0.5;
                } else {
                    dayResult++;
                }
            }
            return dayResult;
        } else if (timeType === 'HOURLY') {
            /**TODO saatlik izinlerde ne kadar giriliyorsa o kadar kabul edilecek
             * let hourResult = Math.floor(hourAmount / 24) * 8;
            if (hourAmount % 24 !== 0) {
                if (hourAmount % 24 > 0 && hourAmount % 24 <= 8) {
                    hourResult += hourAmount % 24;
                } else {
                    hourResult += 8;
                }
            }
            if (absenceTypeId === 22) {
                return Math.floor((hourResult) * 100) / 100;
            } else {
                return Number(hourResult.toFixed(1));
            }*/
            return hourAmount;
        }
    }

  /**
   * eldeki tarihin gununu mevcut ayin ilk gunu olarak atar
   * @param longDateParam
   */
  setStartOfMonth(longDateParam, dateFormat) {
      return moment(new Date(longDateParam), dateFormat);
  }

  setEndOfMonth(longDateParam, dateFormat) {
      return moment(new Date(longDateParam), dateFormat);
  }

    public mapPortalDocumentResponseToFileNameData(param: PortalDocumentResponse[]): FileNameData[] {
        const fileNameDatas: FileNameData[] = [];
        param.forEach(value => {
            const fileNameData: FileNameData = new FileNameData(value.fileName, '');
            fileNameData.alreadyStored = true;
            fileNameData.recordId = value.id;
            fileNameDatas.push(fileNameData);
        });
        return fileNameDatas;
    }

    requireMatch(control: AbstractControl) {
        const selection: any = control.value;
        if (typeof selection === 'string') {
            return {incorrect: true};
        }
        return null;
    }

    tckn(control: AbstractControl) {
        if(control.value == '-'){
            return null;
        }
        else {
            let tcno: any = control.value;
            tcno = tcno.toString();
            const isEleven = /^[0-9]{11}$/.test(tcno);
            let totalX = 0;
            for (let i = 0; i < 10; i++) {
                totalX += Number(tcno.substr(i, 1));
            }
            const isRuleX = totalX % 10 == tcno.substr(10, 1);
            let totalY1 = 0;
            let totalY2 = 0;
            for (let i = 0; i < 10; i += 2) {
                totalY1 += Number(tcno.substr(i, 1));
            }
            for (let i = 1; i < 10; i += 2) {
                totalY2 += Number(tcno.substr(i, 1));
            }
            const isRuleY = ((totalY1 * 7) - totalY2) % 10 == tcno.substr(9, 0);
            if (isEleven && isRuleX && isRuleY === true) {
                return null;
            } else {
                return {incorrect: true};
            }
        }
    }

    getMinuteInterval(absenceTimeType: string) {
        if (absenceTimeType === 'HOURLY') {
            return 5;
        } else {
            return 30;
        }
    }

    /**
     * bu metot saat ve dakika listesi olusturur
     * minuteInterval a gore de dakika araliklari belirlenecek.
     * Ornek: minuteinterval 5 ise 5 er dakikalik liste olacak:
     * 10:00, 10:05, 10:10
     */
    generateHourMinuteList(minuteInterval: number): string[] {
        const result: string[] = [];
        for (let hour = 0; hour <= 23; hour++) {
            for (let minute = 0; minute < 60; minute++) {
                if (minute % minuteInterval === 0) {
                    const modifiedHour = hour < 10 ? '0' + hour : hour; // 10 dan kucuk ise basina 0 ekliyoruz
                    const modifiedMinute = minute < 10 ? '0' + minute : minute;
                    result.push(modifiedHour + ':' + modifiedMinute);
                }
            }
        }
        return result;
    }

    generateHourMinuteListForOvertime(minuteInterval) {
        const result = [];
        for (let hour = 0; hour <= 23; hour++) {
            for (let minute = 0; minute < 60; minute++) {
                if (minute % minuteInterval === 0 && !(hour === 0 && minute === 0)) {
                    const modifiedHour = hour < 10 ? '0' + hour : hour;
                    const modifiedMinute = minute < 10 ? '0' + minute : minute;
                    result.push(modifiedHour + ':' + modifiedMinute);
                }
            }
        }
        result.push("24:00"); // 00:00 yerine 24:00 ekleniyor
        return result;
    }

    converDateToStringWithFormat(dateParam: Date, format: string): string {
        return moment(dateParam).format(format);
    }

    convertStringToDateByFormat(stringParam: string, format: string): Date {
        return moment(stringParam, format).toDate();
    }
}

